var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{attrs:{"id":"localVideo","muted":"","autoplay":"","playsinline":""},domProps:{"muted":true}}),_c('Button',{on:{"click":_vm.entorRoom}},[_vm._v("进入")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }